export default {
  namespaced: true,
  state: {
    meun: [],
    //菜单集合
    currentMenu: 0 //当前选中的菜单，默认是0

  },
  getters: {},
  mutations: {
    set_currentMenu: function set_currentMenu(state, index) {
      state.currentMenu = index;
      console.log(state.currentMenu, '14');
    }
  },
  actions: {}
};